<div
  *ngIf="!deviceOrientation.includes('landscape')"
  class="switcher-wrapper"
  [ngClass]="{ z2: !!openModal }"
>
  <div *ngIf="isMapView" class="switcher-btn" (click)="handleSwitchMapView()">
    <app-shared-icon name="list-unordered-white" class="icon"></app-shared-icon>
    List
  </div>

  <div *ngIf="!isMapView" class="switcher-btn" (click)="handleSwitchMapView()">
    <app-shared-icon name="map-white" class="icon"></app-shared-icon>
    Map
  </div>
</div>
